import * as BABYLON from "babylonjs";
import * as Logger from "js-logger";
import { ResourceLoader } from "../core/resourceLoader";

export class TextureLoader {
   static Load(url: string, scene: BABYLON.Scene): BABYLON.Texture {
       Logger.log("Loading texture: " + url);
       ResourceLoader.registerLoad();
       return new BABYLON.Texture(url, scene, undefined, undefined, undefined, () => { TextureLoader.onLoad(url); }, () => { TextureLoader.onError(url); });
   }

   static onLoad(url: string) {
       ResourceLoader.unregisterLoad();
       Logger.log("Loaded texture: " + url);
   }

   static onError(url: string) {
       ResourceLoader.unregisterLoad();
       Logger.log("Load texture failed: " + url);
   }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/core/textureLoader.ts